import React from "react"
import Page from "./page"

function App(){
  
    return (
      <div style={{justifyContent: 'center'}}>
      
        <Page />
      </div>
    )

}
export default App